module.exports = __webpack_public_path__ + "static/media/auth-bg-1.15f68493.jpg";